<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CwfI9c/tc-custom/9780316515160.jpg?1741987337911" alt="This image is the cover for the book Splintered Suns, Humanity's Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Splintered Suns, Humanity's Fire
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The “proper galaxy-spanning space opera” series continues with a treasure hunt that could unlock an advanced civilization's lost technologies (Ian M. Banks).</b></p><p>For Pyke and his crew of thieves, the plan was simple enough: Travel to a backwater desert planet, break into a museum, steal a tracking device, then use it to find a ship buried in the planet's vast and trackless sandy wastes.</p><p>Except that the museum vault is a bio-engineered chamber, and the tracking device is sought-after by another gang of treasure hunters led by an old adversary of Pyke's, the devious Raven Kaligara. Also, the ship is a quarter of a million years old, about two kilometers long, and somewhere onboard is a mysterious relic that promises to unlock all the treasures and technologies of a lost civilization…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Cobley
      </h2>
      
      <p class="authorDescription body article"><B>Michael Cobley</B> was born in Leicester, England and has lived in Glasgow, Scotland for most of his life. He has studied engineering, been a DJ and has an abiding interest in democratic politics. <br><br>His previous books include the Shadowkings dark fantasy trilogy and <I>Iron Mosaic</I>, a short story collection. <I>Seeds of Earth, The Orphaned Worlds</I>, and <I>The Ascendant Stars</I>, books one, two and three of the Humanity's Fire sequence, were his first full-length forays into space opera.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ca314234